var pym = require("./lib/pym");
var ANALYTICS = require("./lib/analytics");
require("./lib/webfonts");
var { isMobile } = require("./lib/breakpoints");

var onWindowLoaded = function() {
  pym.then(child => {
      child.sendHeight();

      child.onMessage("on-screen", function(bucket) {
          ANALYTICS.trackEvent("on-screen", bucket);
      });
      child.onMessage("scroll-depth", function(data) {
          data = JSON.parse(data);
          ANALYTICS.trackEvent("scroll-depth", data.percent, data.seconds);
      });

      window.addEventListener("resize", () => child.sendHeight());
  });
}

// wait for images to load
window.onload = onWindowLoaded;
